// Explore and a format's Sonar, in the new interface (9 October 2026):
// `pages/epure/ESonar.vue`. The Sonar words the classic screen already had
// (`sonar.statut`, `sonar.mots`, `sonar.titre`, `sonar.relecture`…) are still
// read from `sonar`; only the mock-ups' texts and the audience picker live here.
export default {
  ariane: 'Breadcrumb',
  explorer: {
    sousTitre: 'An open question, put to the audiences you choose',
    vosEtudes: 'Your studies',
  },
  format: {
    titre: 'Sonar',
    sousTitre: 'A question about {titre}, put to its targets: what they choose, what they prefer, what they say about it',
    poseeA: 'Put to your targets, {cibles}',
    poseeAuPanel: 'Put to the format’s panel',
    changer: 'change',
    changerAria: 'Change the targets of {titre}',
    aucune: 'No question about {titre} yet.',
  },
  piste: {
    titre: 'Prepared answers: {titre}',
    aide: 'The panel will choose among these answers; untick the ones to drop. You still review the study before launching it.',
    oublier: 'Do not keep them',
    saison: 'What the panel will know about the season',
    saisonAide: 'Facts only, no ratings or opinions: the panel reads it before answering. Clear it so they know nothing.',
  },
  question: {
    libelle: 'Your question',
    exemples: 'For example:',
    publicRequis: 'Choose at least one audience to ask.',
  },
  heure: {
    libelle: 'Ask as of',
    maintenant: 'Now',
    revenir: 'Back to now',
    passee: 'The twins answer as of that moment.',
    avenir: 'The study will start at that time.',
    commeLe: 'As of {quand}',
    partira: 'It will start on {quand}.',
  },
  publics: {
    libelle: 'Who to ask',
    choisis: 'Chosen:',
    aucun: 'No audience chosen yet.',
    compte: '{n} of {max} at most',
    toutRetirer: 'Remove all',
    retirer: 'Remove {nom}',
    rechercher: 'Search',
    rechercherDans: 'Search: {famille}',
    aucunResultat: 'No audience matches.',
    maximum: '{max} audiences at most: remove one to choose another.',
    termine: 'Done',
    choisisDans: 'none chosen | {n} chosen | {n} chosen',
    chargement: 'Loading the audiences…',
    illisibles: 'The audiences could not be loaded.',
    fermes: 'Choosing audiences is not open to your account.',
    aucunOuvert: 'No audience you can ask is open to your account yet.',
    famille: {
      // The simulation's cities: their twins answer (4 November 2026).
      simulation: 'Cities',
      pays: 'Countries',
      chaine: 'Channels',
      plateforme: 'Platforms',
      jeunes: 'Young audiences',
      thematique: 'Verticals',
      // A country's electorate, for accounts with Polis (11 October 2026).
      politique: 'Politics',
      programme: 'Programme audiences',
      autres: 'Other audiences',
    },
  },
  statut: {
    rendu: 'Delivered',
  },
  vote: {
    questionPosee: 'The question put to the panel',
  },
  relecture: {
    auPlus: 'At most {nb} in the list: remove a few.',
  },
}
